export default __webpack_public_path__ + "static/media/hotel-431f328d8b784ed2d7957e1bc055031e.png";